import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-056dab16"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 1,
  class: "project-square"
}
const _hoisted_4 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isSearched)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("img", { src: _ctx.image }, null, 8, _hoisted_2),
        _createElementVNode("p", null, _toDisplayString(_ctx.projectName), 1)
      ]))
    : (_openBlock(), _createElementBlock("span", _hoisted_3, [
        _createElementVNode("button", {
          class: "project-square-button template-square",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectTemplate()))
        }, [
          _createElementVNode("img", {
            src: _ctx.image,
            class: "template-image"
          }, null, 8, _hoisted_4)
        ]),
        _createElementVNode("p", null, _toDisplayString(_ctx.projectName), 1)
      ]))
}